@if (displayLabel()) {
    <div class="d-flex justify-content-between align-items-baseline gap-3 mb-1">
        <span class="progress-label" [style.font-size]="fontSize()">{{ displayLabel() }}</span>
        @if (showValue()) {
            <span class="progress-value" [style.font-size]="fontSize()">{{ value() | percentageValue }}</span>
        }
    </div>
}

<div class="d-flex align-items-center gap-2">
    <div
        class="progress-track flex-grow-1"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="width()"
        [attr.aria-label]="displayLabel() || null"
        [style.background-color]="background()"
        [style.height.px]="height()"
    >
        <div class="progress-fill" [style.background-color]="colorString()" [style.width.%]="width()"></div>
    </div>

    @if (!displayLabel() && showValue()) {
        <span class="progress-value inline-value" [style.font-size]="fontSize()">{{ value() | percentageValue }}</span>
    }
</div>
